import {MI} from "../init";
import AbstractSymbol from "./AbstractSymbol";
import {getArrayRandValue, getRandomFloat, getRandomInt} from "../../framework/src/helpers";
import MadnesTween from "../libs/mi/MadnesTween";
import {
    madnes_key_exist,
    madnes_set_alpha,
    madnes_set_pos,
    madnes_set_pos_y
} from "../../framework/src/engine/madnes/madnes_object";

/**
 * @constructor
 * @extends {AbstractSymbol}
 * @param {MadnesObject} sprite
 * @param {number} symbolNum
 * @param {number} reelX
 * @param {number} reelY
 */
export default function SymbolCrystal(sprite, symbolNum, reelX, reelY) {
    AbstractSymbol.call(this, sprite, symbolNum, reelX, reelY);

    /** @type {MadnesObject|null} */
    this._winShineObject;
    /** @type {MadnesObject|null} */
    this._sparkle;

    this._blueSparklePos = [
        { 'x': 138, 'y': 26, 'c': 'blue' },
        { 'x': 75, 'y': 50, 'c': 'blue' },
        { 'x': 114, 'y': 167, 'c': 'blue' },
        { 'x': 190, 'y': 156, 'c': 'blue' },
        { 'x': 193, 'y': 78, 'c': 'blue' },
        { 'x': 40, 'y': 86, 'c': 'blue' },
        { 'x': 36, 'y': 154, 'c': 'blue' },
        { 'x': 70, 'y': 58, 'c': 'blue' }
        //{ 'x': 138, 'y': 154, 'c': 'yellow' },
    ];

    this._redSparklePos = [
        { 'x': 35, 'y': 91, 'c': 'red' },
        { 'x': 104, 'y': 24, 'c': 'red' },
        { 'x': 162, 'y': 162, 'c': 'red' },
        { 'x': 68, 'y': 128, 'c': 'red' },
        { 'x': 160, 'y': 26, 'c': 'red' },
        { 'x': 193, 'y': 94, 'c': 'red' },
        { 'x': 113, 'y': 97, 'c': 'red' },
        { 'x': 137, 'y': 153, 'c': 'yellow' }
    ];

    /** @type {MadnesTween|null} */
    this._standTweenScale;

    /** @type {Array<MadnesObject>} */
    this._sparkles = [];
    this._spraklesDiameter = 155;
    this._sparklesOffsetY = -20;

    /** @type {Function|null} */
    this._winAnimResolver;

    this._bluePositions = [
        [50, 72], [47, 66], [26, 118], [52, 40], [118, 20], [159, 72], [56, 58],
        [41, 36], [60, 30], [75, 40], [102, 50], [135, 30], [165, 45],[180, 40],
        [193, 36], [160, 42], [170, 63], [207, 63], [180, 80], [170, 115], [114, 40]
    ];

    this._redPositions = [
        [177, 47], [35, 106], [195, 108], [122, 32], [83, 50], [50, 76], [172, 31],
        [83, 50], [47, 65], [112, 22], [70, 38], [180, 36], [126, 16], [170, 40],
        [53, 38], [41, 62], [67, 15], [134, 25], [89, 24], [196, 121], [195, 70]
    ];
};

SymbolCrystal.prototype = Object.create(AbstractSymbol.prototype);
SymbolCrystal.prototype.constructor = SymbolCrystal;

SymbolCrystal.shineColor = 0xf8c100;

/**
 * @returns {number}
 */
SymbolCrystal.prototype.getShineColor = function() {
    return SymbolCrystal.shineColor;
};

SymbolCrystal.prototype._getColor = function() {
    return this.symbolName === 'symbol_Crystal_blue' ? 'turquoise' : 'red';
};

/**
 * @returns {Array}
 */
SymbolCrystal.prototype._getSparklePosition = function() {
    return this.symbolName === 'symbol_Crystal_blue' ? this._blueSparklePos : this._redSparklePos;
};

SymbolCrystal.prototype._getSparklesPositions = function() {
    return this.symbolName === 'symbol_Crystal_blue' ? this._bluePositions : this._redPositions;
};

SymbolCrystal.prototype.clear = function() {
    //this.parentSprite.setTexture(null);
    this._clearParentSprite();

    this.shineSymbol = null;
    this.destroyShineAnim();

    this._winShineObject = null;
    this._winAnimResolver = null;
    //this._sparkle = null;

    this._stopSparkles();
    for(var i = 0; i < this._sparkles.length; i++) {
        this._sparkles[i].destroy();
    }

    this._sparkles = [];
    this._standTweenScale = null;

    this.removeChilds();
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolCrystal.prototype.createSymbol = function() {
    this.clear();
    this.createImage(0, 0, "symbols_atlas").setFrameName(this.symbolName);

    return this;
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolCrystal.prototype.createSimpleSymbol = function() {
    return this.createSymbol();
};

SymbolCrystal.prototype._createSparkle = function() {
    this._sparkle = this.createImage(0, 0, "symbols_atlas").setBlend("ADD").setFrameName("spark_" + this._getColor()).setVisible(false);
};

SymbolCrystal.prototype._createSparkles = function() {
    for(var i = 0; i < 7; i++) {
        var scale = getRandomFloat(0.6, 1);
        //var rand = MI.getCircleRandInnerPoint(0, 0, this._spraklesDiameter);

        this._sparkles[i] = this.createImage(0, 0, "symbols_atlas").setFrameName("spark_small_" + this._getColor());
        this._sparkles[i].setAlpha(0);
        this._sparkles[i].setScale(scale, scale);
        this._sparkles[i].setAnchor(.5, .5);
        this._sparkles[i]._stopped = true;
    }
};

SymbolCrystal.prototype.createStandAnim = function() {

    this.shineSymbol = this.createImage(0, 0, "symbols_atlas").setFrameName(this.symbolName + "_shine").setBlend("ADD"); //.setScale(1.5, 1.5)
    this.createShineAnim();

    this._createSparkle();
    this._createSparkles();
};

SymbolCrystal.prototype.playStandAnim = function() {
    this._standAnimLoop();
    this._playSparkles();
};

SymbolCrystal.prototype._standAnimLoop = function() {

    if(!AbstractSymbol.spriteExists(this._sparkle)) return;

    /** @type {SymbolCrystal} */
    var _self = this;

    var delay = getRandomInt(500, 1000);
    var duration = getRandomInt(1000, 2000);

    var pos = AbstractSymbol.getRealPosition(getArrayRandValue(this._getSparklePosition()));

    this._sparkle.setPos(pos['x'], pos['y']);
    this._sparkle.setScale(0, 0);
    this._sparkle.setVisible(true);
    this._standTweenScale = MI.addTween().to(this._sparkle, { 'x': 1, 'y': 1 }, {
        'scale': true,
        'delay': delay,
        'duration': duration / 2,
        'easing': MadnesTween.getEasing("quadratic_out"),
        'callback': function() {

            if(!AbstractSymbol.spriteExists(_self._sparkle) || !_self._standTweenScale) return;

            _self._standTweenScale.to(_self._sparkle, { 'x': 0, 'y': 0 }, {
                'scale': true,
                'duration': duration / 2,
                'easing': MadnesTween.getEasing("quadratic_in"),
                'callback': function() {
                    _self._standAnimLoop();
                }
            });
        }
    });
};

/**
 * @param {MadnesObject} sparkle
 */
SymbolCrystal.prototype._sparkleAnim = function(sparkle) {

    if(!AbstractSymbol.spriteExists(sparkle) || sparkle._stopped) return;

    /** @type {SymbolCrystal} */
    var _self = this;

    var pos = AbstractSymbol.getRealPosition(getArrayRandValue(this._getSparklesPositions()));
    var rand = MI.getCircleRandInnerPoint(0, 0, 25);

    var obj = { 'move': 0, 'alpha': 0 };

    madnes_set_pos(sparkle.name, pos[0] + rand['x'], pos[1] + rand['y'], true);

    sparkle['_sparkleTweenMove'] = MI.addTween().to(obj, { 'move': -12 /*getRandomInt(3, 12)*/, 'alpha': 3 }, {
        //'delay': getRandomInt(0, 2000),
        'duration': getRandomInt(1000, 5000),
        'update': () => {

            if(!AbstractSymbol.spriteExists(sparkle)) return;

            madnes_set_pos_y(sparkle.name, pos[1] + obj['move'], true);

            if(obj['alpha'] <= 1) {
                madnes_set_alpha(sparkle.name, obj['alpha']);
            }

            if(obj['alpha'] > 1 && obj['alpha'] < 2) {
                madnes_set_alpha(sparkle.name, 1);
            }

            if(obj['alpha'] >= 2) {
                madnes_set_alpha(sparkle.name, 3 - obj.alpha);
            }
        },
        'callback': function() {
            _self._sparkleAnim(sparkle);
        }
    });
};

SymbolCrystal.prototype._playSparkles = function() {
    for(var i = 0; i < this._sparkles.length; i++) {
        this._sparkles[i]._stopped = false;
        this._sparkleAnim(this._sparkles[i]);
    }
};

SymbolCrystal.prototype._stopSparkles = function() {
    for(var i = 0; i < this._sparkles.length; i++) {
        this._sparkles._stopped = true;

        if(this._sparkles[i]['_sparkleTweenMove']) {
            this._sparkles[i]['_sparkleTweenMove'].stop();
        }
        /*if(this._sparkles[i]._sparkleTweenAlpha) {
            this._sparkles[i]._sparkleTweenAlpha.stop();
        }*/
    }
};

SymbolCrystal.prototype.stopStandAnim = function() {
    this._standTweenScale && this._standTweenScale.stop();
    this._stopSparkles();
};

SymbolCrystal.prototype.fadeOutStandAnim = function() {
    var _self = this;

    var obj = { 'alpha' : 1 };

    MI.addTween().to(obj, { 'alpha': 0 }, {
        'duration': 200,
        'update': function() {
            for(var i = 0; i < _self._sparkles.length; i++) {
                _self._sparkles[i].setAlpha(_self._sparkles[i].getAlpha() * obj['alpha']);
            }

            _self._sparkle.setAlpha(obj['alpha']);
        },
        'callback': function() {
            _self._stopSparkles();

            for(var i = 0; i < _self._sparkles.length; i++) {
                _self._sparkles[i].destroy();
            }
            _self._sparkles.length = 0;

            _self._sparkle.destroy();
        }
    });

    this._standTweenScale && this._standTweenScale.stop();
};

SymbolCrystal.prototype.fadeInStandAnim = function() {
    this._createSparkle();
    this._createSparkles();

    this.playStandAnim();
};

/**
 * @returns {SymbolCrystal}
 */
SymbolCrystal.prototype.createWinSymbol = function() {
    this.createSymbol();

    this._winShineObject = this.createImage(0, 0, this.symbolName + "_atlas")
        .setBlend("ADD").setScale(2, 2).setVisible(false).setAlpha(1);
    this._winShineObject.createAnims();
    this._winShineObject.anims.add("shine", MI.generateFrameNames(this.symbolName + "_", 0, 19, "", 5));

    this._winShineObject.anims.addOnComplete(function() {
        this._winAnimResolver();
    }.bind(this));

    return this;
};

SymbolCrystal.prototype.playWinAnim = function() {
    return new Promise(function(res) {

        this._winAnimResolver = res;

        this._winShineObject.setVisible(true);
        this._winShineObject.anims.play("shine");

    }.bind(this));
};

SymbolCrystal.prototype.stopWinAnim = function() {
    this._winAnimResolver = null;
    this._winShineObject.anims && this._winShineObject.anims.stop();
};

SymbolCrystal.prototype.destroyWinAnim = function() {
    this.stopWinAnim();
    this._winShineObject.destroy();
};